<template>
  <wrapper-edit
    wrapper-width="100%"
    @back="paasPageBack"
    offsetHeight=70>
    <Form ref="paasForm" slot="form"
          :model="paasFormData"
          :rules="paasFormRules"
          :label-width="defaultLabelWidth">
      <Row>
        <FormItem label="功能名称:" prop="title" class="ivu-col-span-12">
          <Input v-model="paasFormData.title" placeholder="功能名称"></Input>
        </FormItem>
        <FormItem label="功能编码:" prop="sysFuncCode" class="ivu-col-span-12">
          <Input v-model="paasFormData.sysFuncCode" placeholder="功能编码"></Input>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="功能类型:" class="ivu-col-span-12" prop="funcType">
          <Enum v-model="paasFormData.funcType"
                :enumJsonKey="'base-funcType'"
                >
          </Enum>
        </FormItem>
        <FormItem label="图标:" prop="iconClass" class="ivu-col-span-12">
          <Input v-model="paasFormData.iconClass" placeholder="图标" >
            <Button slot="append"  @click="funcIcon">
              <Icon :type="paasFormData.iconClass ? paasFormData.iconClass : 'ios-search'">
              </Icon>
            </Button>
          </Input>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="URL:" prop="url" class="ivu-col-span-16" v-if="paasFormData.funcType === 'func'">
          <Input v-model="paasFormData.url" placeholder="URL"></Input>
        </FormItem>
      </Row>
      <Row v-if="paasFormData.funcType === 'func'">
        <FormItem label="英文功能名称:" class="ivu-col-span-12">
          <Input v-model="paasFormData.englishName" placeholder="英文功能名称">
          </Input>
        </FormItem>
        <FormItem label="英文URL:" class="ivu-col-span-12">
          <Input v-model="paasFormData.englishUrl"  placeholder="英文URL" >
          </Input>
        </FormItem>
      </Row>
      <Row v-if="paasFormData.funcType === 'oper'">
        <FormItem label="操作名称:" prop="sysFuncOperId" class="ivu-col-span-12">
          <Select v-model="paasFormData.sysFuncOperId" @on-change="changeFuncOper">
            <Option v-for="oper in opers" :value="oper.id" :key="oper.id">
              {{oper.name}}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="操作编码:" prop="operCode" class="ivu-col-span-12">
          <Input v-model="paasFormData.operCode" placeholder="JS方法名"></Input>
        </FormItem>
      </Row>
      <Row v-if="paasFormData.funcType === 'oper'">
        <FormItem label="操作显示位置:" prop="operShowPosition" class="ivu-col-span-12">
          <Enum v-model="paasFormData.operShowPosition"
                :enumJsonKey="'base-operShowPosition'"
                type="select">
          </Enum>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="显示顺序:" prop="displayOrder" class="ivu-col-span-12">
          <Input v-model="paasFormData.displayOrder" placeholder="显示顺序"></Input>
        </FormItem>
        <FormItem label="父节点:" prop="parentName" class="ivu-col-span-12">
          <Input v-model="paasFormData.parentName"
                 v-if="isAddActive"></Input>
          <Input v-model="paasFormData.parentName"
                 v-if="!isAddActive" @on-focus="changeShowFlag"></Input>
          <select-tree @selected-tree-value="updateTreeParentNode"  :serviceUrl='serviceUrl' v-show="showFlag"/>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="节点图标:" class="ivu-col-span-12">
          <Input v-model="paasFormData.nodeIcon" placeholder="节点图标" >
            <Button slot="append"  @click="nodeIcon">
              <Icon :type="paasFormData.nodeIcon ? paasFormData.nodeIcon : 'ios-search'">
              </Icon>
            </Button>
          </Input>
        </FormItem>
      </Row>
      <div class="edit-oper-toolbar">
        <mButton type="blue" @click="paasFormSubmit('paasForm','','submit')">提交</mButton>
        <mButton type="green" @click="paasFormSubmit('paasForm','','add')">继续添加</mButton>
        <mButton @click="paasPageBack">返回</mButton>
      </div>
      <Modal v-model="funcIconModal" class="paas-select-page" width="80" title="图标选择" :styles="{top: '10px'}">
        <IconSelect @save="saveIcon" type="icon"/>
        <div slot="footer">
        </div>
      </Modal>
      <Modal v-model="nodeIconModal" class="paas-select-page" width="80" title="节点图标选择" :styles="{top: '10px'}">
        <IconSelect @save="saveIcon" type="icon"/>
        <div slot="footer">
        </div>
      </Modal>
    </Form>
  </wrapper-edit>
</template>

<script>
  import { findAllFuncOpers } from "@api/admin.js";
  import wrapperEdit from "@components/paas/wrapper-edit.vue"
  import metaEdit from '@assets/js/meta-tree-edit.js'
  import mButton from '@components/button/m-button.vue'
  import IconSelect from '@components/icon/icon.vue'
  import Enum from '@components/paas/enum-form.vue' //枚举渲染
  import SelectTree from '@components/paas/selectTree.vue'
  export default {
    name: "edit",
    mixins:[metaEdit],
    components:{wrapperEdit,Enum,SelectTree,mButton,IconSelect},
    data(){
      return {
        serviceUrl:"/sys/func",  //每个页面访问后台服务器的路径
        currentIdFiledName: 'id',
        currentNameFiledName: 'title',
        fieldName:'sys_func',
        sysModifyTraceName:'后台管理',
        modifyTraceFiledName:'title',
        paasFormData:{
          id: '',
          title: '',
          sysFuncCode: '',
          nodeCode:'',
          parentId:'',
          parentName:'',
          funcType: '',
          url: '',
          sysFuncOperId: '',
          operCode: '',
          iconClass: '',
          englishName:'',
          englishUrl:'',
          operShowPosition:'',
          nodeIcon:'',
          displayOrder:'',
          isDelete:"",
          icon:"",
        }, //表单数据对象
        paasFormRules:{
          title: [
            { required: true, message: '功能名称不能为空', trigger: 'blur' },
            { type: 'string', message: '功能名称长度不能超过40', trigger: 'blur', max: 40 }
          ],
          sysFuncCode: [
            { type: 'string', message: '功能编码不能超过20字符', trigger: 'blur', max: 20 }
          ],
          funcType: [
            { required: true, message: '功能类型不能为空', trigger: 'blur' }
          ]
        },//表单验证规则
        funcIconModal: false,
        nodeIconModal: false,
        redirectName:'sysFuncList',
        defaultEnumKey:'funcType,operShowPosition',
        nextAddName: 'sysFuncEdit', //保存并添加跳转页面
        opers:[],
        /*isAddActive:false,*/
      }
    },
    methods:{
      /**
       *
       * 选择操作
       * @param val
       */
      changeFuncOper(val) {
        if(val) {
          for(let i = 0; i < this.opers.length; i++) {
            if(val === this.opers[i].id) {
              this.paasFormData.operCode = this.opers[i].operCode;
              this.paasFormData.iconClass = this.opers[i].iconClass;
              this.paasFormData.title = this.opers[i].name
              break;
            }
          }
        }
      },

      // 选择icon
      funcIcon() {
        this.funcIconModal = true;
      },
      nodeIcon(){
        this.nodeIconModal = true;
      },
      saveIcon(item) {
        if(this.nodeIconModal === true){
          this.paasFormData.nodeIcon = item;
          this.nodeIconModal = false;
        }
        if(this.funcIconModal === true){
          this.paasFormData.iconClass = item;
          this.funcIconModal = false;
        }
      },
    },
    created(){
      /**
       * 用于功能修改页面，功能类型为操作时，显示的操作数据
       */
      findAllFuncOpers().then(
        res=>{
          if(res.code === 200){
            this.opers = res.data
          }
        }
      ).catch(
        error=>{
          this.$Message.info('操作列表查询失败')
        }
      )
    }
  }
</script>

<style scoped>
  .whead {
    height: 38px;
    color: #636363;
    background: #f8f8f8;
    background: -webkit-gradient(linear, left top, left bottom, from(#f8f8f8),to(#e8e8e8));
    background: linear-gradient(to bottom, #f8f8f8 0%,#e8e8e8 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f8f8f8', endColorstr='#e8e8e8',GradientType=0 );
  }
  .wrapper{
    margin:0px;
  }
  .ivu-form{
    width:80%;
    margin:0px auto;
  }
</style>
